import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { of } from 'rxjs';
import { first, switchMap, tap } from 'rxjs/operators';
import { ClientService } from '../../../domain/services';
import { ChangesNotSavedComponent } from '../../../shared/changes-not-saved';
import { GoogleAnalyticsService } from '../../../shared/service/google-analytics.service';
import { YourEducationFormComponent } from '../../components';
import { Application } from '../../models';
import { applicationPresent } from '../../operators';
import { CurrentApplicationService } from '../../services';
import { ApplicationService } from './../../../application/services';

@Component({
    selector: 'app-your-education',
    templateUrl: './your-education.component.html',
    styleUrls: ['./../../application-page.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class YourEducationComponent
    extends ChangesNotSavedComponent
    implements OnInit
{
    submitted = false; // because we are extending ChangesNotSavedComponent

    fields$ = this._client.latest.pipe(
        switchMap((client) => this._client.getClientFields(3))
    );

    formValue$ = this._currentApplication.latest.pipe(
        applicationPresent(),
        first(),
        switchMap((application: Application) => {
            if (application?.applicationId) {
                return this.applicationService.getEducation(
                    application.applicationId!
                );
            } else return of(null);
        })
    );

    @ViewChild(YourEducationFormComponent) form:
        | YourEducationFormComponent
        | undefined;

    constructor(
        private readonly applicationService: ApplicationService,
        private readonly snackBar: MatSnackBar,
        private readonly router: Router,
        private readonly _transloco: TranslocoService,
        private readonly _currentApplication: CurrentApplicationService,
        private readonly _client: ClientService,
        private readonly _googleAnalyticsService: GoogleAnalyticsService
    ) {
        super();
    }

    ngOnInit() {
        this._googleAnalyticsService.pageView('Application: Your Education');
    }

    onSubmitted(education: any) {
        this.applicationService
            .saveEducation(education)
            .pipe(
                switchMap(() =>
                    this._transloco
                        .selectTranslate('application.snack.saved')
                        .pipe(first())
                ),
                tap((message) => {
                    this.snackBar.open(message, undefined, {
                        duration: 4000
                    });
                    this.postSubmit();
                })
            )
            .subscribe();
    }

    postSubmit() {
        this.submitted = true;
        this._currentApplication.load();
        this.router.navigateByUrl(
            `${runtimeConfig.clientCode}/application/disclosure`
        );
    }

    isChanged(): boolean {
        return this.form?.touched ?? false;
    }

    isSaved(): boolean {
        return this.submitted;
    }
}
